import api from "../utils/axios";

export const endpoint = "work-order-task-user";

const baseUrl = `/api/${endpoint}/`;

export function getAssignedTask() {
  return api.get(`${baseUrl}get-assigned-task`);
}

export function getUserAssigned() {
  return api.get(`${baseUrl}get-user-assigned`);
}

export function update(id) {
  return api.put(`${baseUrl}update`, {
    id,
  });
}

export function play(request) {
  return api.post(`${baseUrl}play`, {
    ...request,
  });
}
